// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let PammBase = function () { };

PammBase.FUND_TYPE_CLOSE = 0;
PammBase.FUND_TYPE_OPEN = 1;